import { Mail, ChevronDown, ChevronUp, User } from "lucide-react";
import { useState } from "react";
import { UtilApp } from "../../services/Utils/UtilApp";
import { UIMessage } from "./UIMessage";
import { My } from "../../services/My";
import { Avatar, AvatarFallback, AvatarImage } from "../../components/ui/avatar";
import { Util } from "../../services/Utils/Util";

interface IMessageItem {
  m: UIMessage,
}

const MessageEmailItem: React.FC<IMessageItem> = ({ m }) => {
  const [hide, setHide] = useState(true);

  return (
    <div className="flex flex-col gap-2 p-2">
      {m.msg.text && (
        <div
          className="flex flex-col bg-white border rounded-lg overflow-hidden cursor-pointer transition-shadow hover:shadow-sm"
          onClick={() => setHide(!hide)}
        >
          <div className="flex items-center gap-3 p-3 bg-gray-50 border-b">
            <div className="flex items-center justify-center w-8 h-8 rounded-full bg-green-100 text-green-600">
              <Mail className="w-4 h-4" />
            </div>

            <div className={`text-sm text-gray-800 line-clamp-2 flex-1 ${hide ? "line-clamp-1" : ""}`}>
              {hide ? "Click to expand email content..." : "Email Content"}
            </div>

            <div className="text-gray-400">
              {hide ? <ChevronDown className="w-5 h-5" /> : <ChevronUp className="w-5 h-5" />}
            </div>
          </div>

          <div className={`p-4 text-sm text-gray-700 bg-white whitespace-pre-wrap transition-all duration-300 ${hide ? "hidden" : "block"}`}>
            {m.msg.text}
          </div>
        </div>
      )}

      <div className="flex items-center gap-3 pl-1">
        {m.msg.senderEmail === m.msg.user.email ? (
          <>
            <Avatar className="w-8 h-8 rounded-full">
              <AvatarImage src={m.msg.user.photoUrl || Util.ANONYMOUS_PHOTO_URL} alt={m.msg.user.name} />
              <AvatarFallback>{m.msg.user.name?.[0]}</AvatarFallback>
            </Avatar>
            <div className="flex flex-col">
              <span className="text-sm font-semibold text-gray-900">{m.msg.user.name}</span>
              <span className="text-[10px] text-gray-500">{UtilApp.dateStrToTime(m.msg.created)}</span>
            </div>
          </>
        ) : (
          <>
            <Avatar className="w-8 h-8 rounded-full bg-gray-100">
              <AvatarFallback><User className="w-4 h-4 text-gray-500" /></AvatarFallback>
            </Avatar>
            <div className="flex flex-col">
              <span className="text-sm font-semibold text-gray-900">{m.msg.senderEmail}</span>
              <span className="text-[10px] text-gray-500">{UtilApp.dateStrToDay(m.msg.created, My.user.lang)}</span>
            </div>
          </>
        )}
      </div>
    </div >
  );
}

export default MessageEmailItem;